import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import Navigation from "./Components/Navigation";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Home from "./Components/Pages/Home";
import { constants } from "./Bootstrap";
import { parseURLParams, doRequest } from "./helper";

//for fir india module
import FitIndiaModeration from "./Components/FitIndia/Moderation";
import FitIndiaAddVideo from "./Components/FitIndia/AddVideo";
import FitIndiaManageVideos from "./Components/FitIndia/ManageVideos";
import FitIndiaAddSocial from "./Components/FitIndia/AddSocial";
import TwitterFeed from "./Components/FitIndia/Feeds/Twitter";

//for sampark abhiyan
import AddInfographics from "./Components/Sampark/AddInfographics";
import ManageInfographics from "./Components/Sampark/ManageInfographics";
import SamparkModeration from "./Components/Sampark/Moderation";
import UserListing from "./Components/Sampark/UserListing";
import PostCount from "./Components/Sampark/user";

//for NM Birthday
import AddPledge from "./Components/NM_Birthday_Module_2018/AddPledge";
import ManagePledge from "./Components/NM_Birthday_Module_2018/ManagePledge";
import BrdyModeration from "./Components/NM_Birthday_Module_2018/Moderation";
import MbsbModeration from "./Components/Mbsb/Moderation";

//for Mai Bhi Chowkidar
import MaiBhiChowkidarModeration from "./Components/MaiBhiChowkidar/Moderation";

import BdayAddSocial from "./Components/NM_Birthday_Module_2018/AddSocial";
import BdayTwitterFeed from "./Components/NM_Birthday_Module_2018/Feeds/Twitter";

//for Birthday 2019

import Bday2019 from "./Components/Nmbday2020/Moderation";
import Bday2021 from "./Components/Nmbday2021/Moderation";
import Rb2020 from "./Components/Rb2020/Moderation";
import Bday2020 from "./Components/Nmbday2020/Moderation";
import KamalPushpa from "./Components/KamalPushpa/Moderation";
import HarGharTirangaModeration from "./Components/HarGharTiranga/Moderation";
import BirthdaySevaModeration from "./Components/BirthdaySeva/Moderation";
import GujaratElection from "./Components/GujaratElection/Moderation";
import Count from "./Components/GujaratElection/Count";
import Moderation from "./Components/ExamYuva/Moderation";
import ExamYuvaModeration from "./Components/ExamYuva/Moderation";
import $ from "jquery";
import MotherhoodWallModeration from "./Components/MotherhoodWall/Moderation";
import MahilaDateCount from "./Components/MahilaMorcha/MahilaDateCount";
import MahilaMorchaCopy from "./Components/MahilaMorcha/MahilaMorchaCopy";
import HarGharVikas from "./Components/HarGharVikas/Moderation";
import SamarkSeSamarthan from "./Components/SamparkSeSamarthan/Moderation";
import Dashboard from "./Components/HarGharVikas/Dashboard";
import SmDashboard from "./Components/SamparkSeSamarthan/Dashboard";
import MahilaStatewiseCount from "./Components/MahilaMorcha/MahilaStatewiseCount";
import Mkb100 from "./Components/Mkb100/Moderation";
import VocalForLocal from "./Components/VocalForLocal/Moderation";
import VocalDashboard from "./Components/VocalForLocal/Dashboard";
import ImageUpload from "./Components/VocalForLocal/ImageUpload";
import UplaodList from "./Components/VocalForLocal/UplaodList";
import Viksitdashboard from "./Components/ViksitBharat/Viksitdashboard";
import ViksitBharatSelfie from "./Components/ViksitBharatSelfie/ViksitBharatSelfie";
import VbActivityModeration from "./Components/Vbactivity/Moderation";
import SwachhteerthModeration from "./Components/SwachhTeerth/Moderation";
import ViksitUserdashboard from "./Components/ViksitBharat/ViksitUserdashboard";
import ViksitVbadashboard from "./Components/ViksitBharat/ViksitVbadashboard";
import Rreport from "./Components/SwachhTeerth/Report";
import ModiparivarModeration from "./Components/ModiParivar/Moderation";
import ModiRallyModeration from "./Components/ModiRally/Moderation";
import IndianDiasporaModeration from "./Components/IndianDiaspora/Moderation";

class App extends Component {
  componentDidMount() {
    //before this check id token in the url
    var hash = window.location.hash;
    if (hash.indexOf("id_token") != -1 && hash.indexOf("access_token") != -1) {
      var hashParams = hash.split("&");
      var id_token = hashParams[0].substr(
        "#id_token=".length,
        hashParams[0].length
      );
      var access_token = hashParams[1].substr(
        "access_token=".length,
        hashParams[1].length
      );

      localStorage.setItem("id_token", id_token); //these should be used with each request, then only api will work
      localStorage.setItem("access_token", access_token);

      //verify this id token
    }

    if (!localStorage.getItem("id_token")) {
      //no token specified
      window.location.href = constants.loginUrl;
    } else {
      doRequest("cms-operations", { action: "list" }, true); // this is to check login even if token specified
    }
  }
  render() {
    return (
      <BrowserRouter>
        <div id="wrapper">
          <Navigation />
          <div id="page-wrapper" className="gray-bg">
            <div className="row border-bottom">
              <Header />
            </div>

            <Switch>
              <Route exact path="/" component={Bday2020} />
              <Route
                exact
                path="/meihumodiparivar/moderation/:status?"
                component={ModiparivarModeration}
              /> <Route
                exact
                path="/indiandiaspora/moderation/:status?"
                component={IndianDiasporaModeration}
              />
              <Route
                exact
                path="/examyuva/moderation/:status?"
                component={ExamYuvaModeration}
              />
              <Route exact path="/rb2020/moderation" component={Rb2020} />
              <Route
                exact
                path="/rb2020/moderation/:status?"
                component={Rb2020}
              />
              <Route
                exact
                path="/motherhoodwall/moderation/:status?"
                component={MotherhoodWallModeration}
              />
              <Route exact path="/nmbday2019/moderation" component={Bday2019} />
              <Route exact path="/nmbday2020/moderation" component={Bday2020} />
              <Route
                exact
                path="/nmbday2019/moderation/:status?"
                component={Bday2019}
              />
              <Route
                exact
                path="/myseva/moderation/:status?"
                component={Bday2021}
              />
              <Route
                exact
                path="/kamalpushpa/moderation/:status?"
                component={KamalPushpa}
              />
              <Route
                exact
                path="/nmbday2020/moderation/:status?"
                component={Bday2020}
              />

              <Route
                exact
                path="/fit-india/moderation/:status?/:page?"
                component={FitIndiaModeration}
              />
              <Route
                exact
                path="/fit-india/add-videos"
                component={FitIndiaAddVideo}
              />
              <Route
                exact
                path="/fit-india/manage-videos"
                component={FitIndiaManageVideos}
              />
              <Route
                exact
                path="/fit-india/add-social"
                component={FitIndiaAddSocial}
              />
              <Route exact path="/fit-india/twitter" component={TwitterFeed} />

              <Route
                exact
                path="/sampark/moderation/:status?/:page?"
                component={SamparkModeration}
              />
              <Route
                exact
                path="/sampark/add-infographics"
                component={AddInfographics}
              />
              <Route
                exact
                path="/sampark/manage-infographics"
                component={ManageInfographics}
              />
              <Route
                exact
                path="/sampark/moderation"
                component={SamparkModeration}
              />
              <Route
                exact
                path="/sampark/userlisting"
                component={UserListing}
              />
              <Route exact path="/sampark/PostCount" component={PostCount} />

              <Route
                exact
                path="/NMBirthday/moderation/:status?/:page?"
                component={BrdyModeration}
              />
              {/* <Route exact path="/NMBirthday/add-pledge" component={AddPledge} /> 
                            <Route exact path="/NMBirthday/manage-pledge" component={ManagePledge} /> */}
              <Route
                exact
                path="/NMBirthday/moderation"
                component={BrdyModeration}
              />

              <Route
                exact
                path="/NMBirthday/add-social"
                component={BdayAddSocial}
              />
              <Route
                exact
                path="/NMBirthday/twitter"
                component={BdayTwitterFeed}
              />
              <Route
                exact
                path="/mbsb/moderation/:status?/:page?"
                component={MbsbModeration}
              />
              <Route
                exact
                path="/maibhiChowkidar/moderation/:status?/:page?"
                component={MaiBhiChowkidarModeration}
              />
              <Route
                exact
                path="/mkb100/moderation/:status?"
                component={Mkb100}
              />
              <Route
                exact
                path="/harghartiranga/moderation/:status?"
                component={HarGharTirangaModeration}
              />
              <Route
                exact
                path="/gujaratelection/moderation/:status?"
                component={GujaratElection}
              />
              <Route
                exact
                path="/gujaratelection/count/:status?"
                component={Count}
              />
              <Route
                exact
                path="/mahilamorcha/moderation/:status?"
                component={MahilaMorchaCopy}
              />
              <Route
                exact
                path="/mahilamorcha/Gridview/:status?"
                component={MahilaDateCount}
              />
              <Route
                exact
                path="/mahilamorcha/StateWiseCount/:status?"
                component={MahilaStatewiseCount}
              />
              <Route
                exact
                path="/vocalforlocal/moderation/:status?"
                component={VocalForLocal}
              />
              <Route
                exact
                path="/vocalforlocal/dashboard/:status?"
                component={VocalDashboard}
              />
              <Route
                exact
                path="/vocalforlocal/uploadlist/:status?"
                component={UplaodList}
              />
              <Route
                exact
                path="/viksitbharatselfie/moderation/:status?"
                component={ViksitBharatSelfie}
              />
              <Route
                exact
                path="/vocalforlocal/upload/:id?"
                component={ImageUpload}
              />
              <Route
                exact
                path="/viksitbharat/dashboard/:status?"
                component={Viksitdashboard}
              />
              <Route
                exact
                path="/viksitbharat/userdashboard/:status?"
                component={ViksitUserdashboard}
              />
              <Route
                exact
                path="/viksitbharatuser/vbadashboard/:status?"
                component={ViksitVbadashboard}
              />
              {/* <Route
                exact
                path="/hargharvikas/moderation/:status?"
                component={HarGharVikas}
              />
              <Route
                exact
                path="/hargharvikas/dashboard/:status?"
                component={Dashboard}
              />
              <Route
                exact
                path="/samparksesamarthan/moderation/:status?"
                component={SamarkSeSamarthan}
              />
              <Route
                exact
                path="/samparksesamarthan/dashboard/:status?"
                component={SmDashboard}
              /> */}
              <Route
                exact
                path="/vbactivity/moderation/:status?"
                component={VbActivityModeration}
              />
              <Route
                exact
                path="/modirally/moderation/:status?"
                component={ModiRallyModeration}
              />
              <Route
                exact
                path="/swachhteerth/moderation/:status?"
                component={SwachhteerthModeration}
              />
              <Route
                exact
                path="/swachhteerth/report/:status?"
                component={Rreport}
              />
              <Route
                exact
                path="/birthdayseva/moderation/:status?"
                component={BirthdaySevaModeration}
              />
              <Route component={Home} />
            </Switch>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx